import { util } from 'echarts';
import { type ThemeParser } from '../../../core/theme';
import { type Option } from '../../../core/option';
import { normalizeToArray } from '../../../util/utils';
import type { PresetMode } from '../..';
import { FONT_LEVEL_LIST, FONT_SIZE_LIST, fontColor } from '../../mobile/static/font';
import { Z_LIST } from '../../mobile/static/z';

type YAxisOption = Parameters<ThemeParser>[0]['yAxis'] & {
  dvSplitLineNumber: number;
  dvBoundaryGapContainZeroTick: boolean;
  splitLine: {
    dvZ: number;
  };
};

const DEFAULT_SPLIT_LINE_NUMBER = 5;

export function preporcessYAxis(option: Parameters<ThemeParser>[0]) {
  option.yAxis = normalizeToArray(option.yAxis || {}) as Option['yAxis'];
}

export function defaultYAxisOpt(themeMode: PresetMode) {
  return {
    dvSplitLineNumber: DEFAULT_SPLIT_LINE_NUMBER,
    dvBoundaryGapContainZeroTick: true,
    /**
     * 这里的百分比的参考是实际的option.maxmin/data的maxmin(先后顺序表示优先级)的差值 或 min本身(插值为0时)
     * @description 应设计师要求，series绘制占图表上下各90%
     * @change - 2024-02-28 应设计师要求，series的最小值无需再减少原始区间的10%，
     * 以防止没有跨0轴的数据在图表中y轴跨0轴的奇怪现象
     */
    boundaryGap: [0, '10%'],
    position: 'right',
    splitLine: {
      dvZ: 0,
      lineStyle: {
        width: 0.5,
        color: themeMode === 'light' ? 'rgba(0, 0, 0, 0.1)' : 'rgba(255, 255, 255, 0.1)'
      }
    },
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    axisLabel: {
      inside: true,
      verticalAlign: 'bottom',
      color: fontColor(FONT_LEVEL_LIST.LEVEL2, themeMode),
      fontSize: FONT_SIZE_LIST.axisLabel,
      fontFamily: 'sans-serif',
      margin: 0,
      dvAlignEdge: true
    },
    z: Z_LIST.axis
  };
}

export function parseYAxis(option: Parameters<ThemeParser>[0], defaultYAxis: YAxisOption) {
  const yAxisArr = option.yAxis as unknown as [];
  yAxisArr.forEach((yAxis, index) => {
    const defaultYAxisTemplate = util.clone(defaultYAxis);
    if (index > 0 && !yAxis.position) {
      defaultYAxisTemplate.position = 'left';
    }
    option.yAxis[index] = util.merge(defaultYAxisTemplate, yAxis, true);
  });
}

export function yAxisThemeParse(...args: Parameters<ThemeParser>) {
  const [option, chart] = args;
  const themeMode = chart.getModel().getThemeName().includes('light') ? 'light' : 'dark';
  preporcessYAxis(option);
  parseYAxis(option, defaultYAxisOpt(themeMode));
}
